import { useEffect, useRef, useState } from "react";
import { useQuestionnaires } from "./useQuestionnaires";
import { useQuestionnaireResponses } from "./useQuestionnaireResponses";
import { useMedicalCareContext } from "../contexts/MedicalCareContext";
import { useQuestionnaireContext } from "../contexts/QuestionnaireContext";
import { useLocation } from "react-router-dom";

export function useQuestionnairesTab() {
  const { appointment } = useMedicalCareContext();
  const { state } = useLocation();
  const patientIdFromAppointment = appointment?.participant
    ?.find((participant: any) => participant.reference?.includes("Patient"))
    ?.reference?.split("/")[1];
  const patientIdFromState = state?.encounterReference?.subject;
  const patientId = patientIdFromAppointment || patientIdFromState;
  const encounterId = state?.encounterReference?.id;

  const { questionnaires, loading, error, fetchQuestionnaires } =
    useQuestionnaires({
      count: 50,
      status: "active",
      tag: "sleep",
    });

  const { setSelectedHistoryQuestionnaireId } = useQuestionnaireContext();

  const { responses: questionnaireResponses, fetchResponses } =
    useQuestionnaireResponses({
      patientId: patientId?.toString(),
      tag: "questionnaires",
    });

  const [selectedQuestionnaire, setSelectedQuestionnaire] = useState<any>(null);
  const [showHistory, setShowHistory] = useState(false);
  const [historyQuestionnaireId, setHistoryQuestionnaireId] = useState<
    string | null
  >(null);
  const hasFetchedRef = useRef<boolean>(false);

  useEffect(() => {
    if (!hasFetchedRef.current) {
      fetchQuestionnaires();
      hasFetchedRef.current = true;
    }
  }, []);

  const handleViewHistory = (questionnaire: any) => {
    const questionnaireRef = `Questionnaire/${questionnaire.id}`;
    setHistoryQuestionnaireId(questionnaireRef);
    setSelectedHistoryQuestionnaireId(questionnaireRef);
    setShowHistory(true);
  };

  const handleBackFromHistory = () => {
    fetchResponses();
    setShowHistory(false);
    setHistoryQuestionnaireId(null);
  };

  const handleQuestionnaireSubmit = async () => {
    const questionnaireRef = `Questionnaire/${selectedQuestionnaire.id}`;
    setHistoryQuestionnaireId(questionnaireRef);
    setSelectedHistoryQuestionnaireId(questionnaireRef);
    setSelectedQuestionnaire(null);
  };

  const handleSelectQuestionnaire = (questionnaire: any) => {
    setSelectedHistoryQuestionnaireId(null);
    setSelectedQuestionnaire(questionnaire);
  };

  const handleBackFromForm = () => {
    setSelectedQuestionnaire(null);
  };

  return {
    questionnaires,
    loading,
    error,
    selectedQuestionnaire,
    showHistory,
    historyQuestionnaireId,
    questionnaireResponses,
    patientId,
    encounterId,

    handleViewHistory,
    handleBackFromHistory,
    handleQuestionnaireSubmit,
    handleSelectQuestionnaire,
    handleBackFromForm,
    fetchResponses,
  };
}
